import { mapState } from 'vuex';

import ctt from '@/utils/const';
import { runstateText, pointState } from '@/utils/dict';
import { translateTo } from '@/utils/locale';
import { isArray, isFunction, isMobile, isString } from '@/utils/is';
import { i18n } from '@/locale';

export default {
  install: function (Vue, _options) {
    Vue.mixin({
      filters: {
        stateText(state) {
          return pointState[state];
        },
        stateClass(state, green) {
          state = state === undefined ? ctt.POINT_STATE_UNCONNECT : state;
          const {
            POINT_STATE_CONNECT,
            POINT_STATE_UNCONNECT,
            POINT_STATE_WARN,
            POINT_STATE_DANGER,
            POINT_STATE_FAULT,
            POINT_STATE_FIX,
            POINT_STATE_COLLECT,
            POINT_STATE_GREEN
          } = ctt;
          switch (state) {
            case POINT_STATE_UNCONNECT:
              return 'unconnect-color';
            case POINT_STATE_CONNECT:
              if (green) {
                return 'success-color';
              } else {
                return 'normal-color';
              }
            case POINT_STATE_WARN:
              return 'warning-color';
            case POINT_STATE_DANGER:
              return 'danger-color';
            case POINT_STATE_FIX:
              return 'fix-color';
            case POINT_STATE_FAULT:
              return 'fault-color';
            case POINT_STATE_COLLECT:
              return 'collect-color';
            case POINT_STATE_GREEN:
              return 'success-color';
          }
        },
        runstateText(state) {
          return runstateText[state];
        },
        runstateTextI18n(state) {
          return i18n.t(runstateText[state]);
        },
        runstateClass(state, green) {
          state = state === undefined ? ctt.POINT_STATE_UNCONNECT : state;
          const { RUNSTATE_NORMAL, RUNSTATE_FIX, RUNSTATE_FAULT, RUNSTATE_COLLECT } = ctt;
          switch (state) {
            case RUNSTATE_NORMAL:
              if (green) {
                return 'success-color';
              } else {
                return 'normal-color';
              }
            case RUNSTATE_FIX:
              return 'fix-color';
            case RUNSTATE_FAULT:
              return 'fault-color';
            case RUNSTATE_COLLECT:
              return 'collect-color';
          }
        },
        borderStyle(state) {
          if (state === ctt.POINT_STATE_DANGER) {
            return 'danger-color';
          } else if (state === ctt.POINT_STATE_WARN) {
            return 'warn-color';
          }
        },
        translateTo(text, path, option = {}) {
          return translateTo(text, path, option);
        }
      },
      computed: {
        ...mapState('admin', ['authMenu', 'addRoutes']),
        isEnglish() {
          return this.$i18n.locale === 'en';
        },
        isChinese() {
          return this.$i18n.locale.includes('zh');
        },
        isMobile() {
          return isMobile();
        }
      },
      methods: {
        getStateText(state) {
          return pointState[state];
        },
        translateTo(text, path, option) {
          return translateTo(text, path, option);
        },
        /**
         * @param {'en'|'zh'|'ar'|'es'|'fr'|'ru'} langs
         */
        inLangs(langs) {
          let ls = [];

          if (isArray(langs)) {
            ls = langs;
          } else if (isString(langs)) {
            ls = langs.split(/[,\s]/);
          }

          return ls.some(e => {
            return this.$i18n.locale.indexOf(e) != -1;
          });
        },
        pushToHomePage() {
          this.$router.push(
            this.addRoutes && this.addRoutes[0] && this.addRoutes[0].path !== '*'
              ? this.addRoutes[0].path
              : '/login'
          );
        }
      },
      watch: {
        '$i18n.locale'(val, old) {
          if (isFunction(this.langChangeHandler)) {
            this.langChangeHandler(val, old);
          }
        }
      }
    });
  }
};
